(function(window, responsiveControllerFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.responsiveController = responsiveControllerFactory(window.$);
})(this, function($) {
   'use strict';

   /**
    * @memberof TSC
    * @class responsiveController
    * @classdesc Control responsive classes on player container
    */

   var _intervalID = null;
   var _$container = null;
   var _currentContainerSize = {
      width: null,
      height: null
   };

   var _responsiveBreakpoints = {
      'small-mobile': {
         width: 1,
         height: 1
      },
      'medium-mobile': {
         width: 250,
         height: 250
      },
      'small-desktop': {
         width: 400,
         height: 400
      }
   };

   var checkForResize = function() {
      if (_$container.width() !== _currentContainerSize.width || _$container.height() !== _currentContainerSize.height) {
         _currentContainerSize.width = _$container.width();
         _currentContainerSize.height = _$container.height();
         _$container.trigger('resize', _currentContainerSize);
      }
   };

   var monitorContainerSize = function($container) {
      if (_intervalID) {
         clearInterval(_intervalID);
      }

      _$container = $container;

      // check for resize 4x/sec
      _intervalID = setInterval(checkForResize, 250);
   };

   var manageResponsiveClasses = function() {
      if (!_$container) {
         return;
      }

      $.each(_responsiveBreakpoints, function(key, breakpoint) {
         var widthClassName = [key, 'width'].join('-');
         var heightClassName = [key, 'height'].join('-');

         if (breakpoint.width && _currentContainerSize.width > breakpoint.width) {
            _$container.addClass(widthClassName);
         } else {
            _$container.removeClass(widthClassName);
         }
         if (breakpoint.height && _currentContainerSize.height > breakpoint.height) {
            _$container.addClass(heightClassName);
         } else {
            _$container.removeClass(heightClassName);
         }
      });
   };

   var forgetContainerSize = function() {
      if (_intervalID) {
         clearInterval(_intervalID);
      }
      _intervalID = null;
      _$container = null;
      _currentContainerSize = {
         width: null,
         height: null
      };
   };

   return {
      /**
       *  Monitor a jquery element for a change in size
       *  @function monitorContainerSize
       *  @param {Object} $container - jquery element to monitor
       *  @memberof TSC.responsiveController
       *  @static
       */
      monitorContainerSize: monitorContainerSize,
      /**
       *  Forget to monitor a jquery element for a change in size
       *  @function forgetContainerSize
       *  @param {Object} $container - jquery element to monitor
       *  @memberof TSC.responsiveController
       *  @static
       */
      forgetContainerSize: forgetContainerSize,
      /**
       *  Adds or removes responsive class to the specified container.
       *  @function manageResponsiveClasses
       *  @param {Object} $container - jquery element to apply classes to.
       *  @memberof TSC.responsiveController
       *  @static
       */
      manageResponsiveClasses: manageResponsiveClasses
   };
});
